import { render, staticRenderFns } from "./beenSetting.vue?vue&type=template&id=57f0b09e&scoped=true&"
import script from "./beenSetting.vue?vue&type=script&lang=js&"
export * from "./beenSetting.vue?vue&type=script&lang=js&"
import style0 from "./beenSetting.vue?vue&type=style&index=0&id=57f0b09e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f0b09e",
  null
  
)

export default component.exports